import React, { Component } from 'react'
import './Layout.css'
import classNames from 'classnames'
import Heading from '../../Components/Heading/Heading'
import Text from '../../Components/Text/Text'
import Image from '../../Components/Image/Image'
import Video from '../../Components/Video/Video'

class Layout extends Component {
  renderComponent (c, i) {
    let { currentSlide, slideIndex } = this.props

    switch (c.componentType) {
      case 'heading':
        return (<Heading key={i} level={c.headingLevel} text={c.text} />)
      case 'text':
        return (<Text key={i} text={c.text} style={c.style} />)
      case 'image':
        return (<Image key={i} src={c.src} />)
      case 'video':
        return (<Video key={i} src={c.src} bgColor={c.bgColor} currentSlide={currentSlide} slideIndex={slideIndex} />)
      default:
        return null
    }
  }

  render () {
    const { type, content } = this.props

    let classes = classNames({
      'Layout': true,
      'm-LayoutFull': type === 'full',
      'm-LayoutSplit': type === 'split'
    })

    return (
      <div>
        {type === 'full' &&
          <div className={classes}>
            {content.components.map((c, i) => {
              return this.renderComponent(c, i)
            })}
          </div>
        }
        {type === 'split' &&
          <div className={classes}>
            <div>
              <div className='Layout-Main'>
                {content.left.main.components.map((c, i) => {
                  return this.renderComponent(c, i)
                })}
              </div>
              <div className='Layout-Footnotes'>
                {content.left.footnotes.components.map((c, i) => {
                  return this.renderComponent(c, i)
                })}
              </div>
            </div>
            <div>
              {content.right.components.map((c, i) => {
                return this.renderComponent(c, i)
              })}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Containers/Layout/Layout.js